module.exports = __webpack_public_path__ + "img/kiwix.png";